// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-bucket-selector{align-items:baseline;display:flex;font-size:14px}.mp-bucket-selector mp-select{font-size:14px}.mp-bucket-selector .mp-bucket-selector-label{color:var(--tertiary-text-color);line-height:1;padding-right:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
